"use client";

import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import {
  PLATE_NUMBER_CLASS_NAME,
  formatPlateNumberValue,
} from "@/lib/fleet/plate-number";

interface PlateNumberProps extends HTMLAttributes<HTMLSpanElement> {
  plate?: string | null;
}

export function PlateNumber({ plate, children, className, ...props }: PlateNumberProps) {
  const text = children ?? formatPlateNumberValue(plate);

  return (
    <span className={cn(PLATE_NUMBER_CLASS_NAME, className)} {...props}>
      {text}
    </span>
  );
}
